import {useEffect, useState} from 'react'

const isDocumentVisible = () => Boolean(document?.visibilityState === 'visible')

/**
 * Observes document visibility state
 * @returns Whether the document is currently visible
 */
export const useDocumentVisibility = () => {
  const [isVisible, setIsVisible] = useState<boolean>(
    typeof window !== 'undefined' && isDocumentVisible()
  )

  useEffect(() => {
    const onVisibilityChange = () => setIsVisible(isDocumentVisible())
    document.addEventListener('visibilitychange', onVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [])

  return isVisible
}
